export default __webpack_public_path__ + "static/media/mall1.ab114bc9.jpg";